import { SquaresContext } from 'global/wrappers/SquaresWrapper'
import { useContext, useEffect, useState } from 'react'
import { Segment } from 'semantic-ui-react'
import { SettingParentContext } from '../../../cnr/contexts/SettingParentContext'
import { getStaticName } from '../../../common/convert'
import AppForm from '../../../components/forms/appForms/AppForm'
import { appFormTypes } from '../../../enums/appFormTypes'
import { gEnums } from '../../../enums/globalEnums'

const showLogs = false

const DataConstraintBuilder = (props) => {

  const {
    viewItem_current,
    formItemType,
    allGroups,
    handle_formUpdate,
    currentPath,
    currentPathFull,
    currentGroup,
    currentData,
    currentViProps,
  } = props ?? {}

  let _currentGroup = currentGroup;

  _.forEach(allGroups, (group, groupKey) => {
    if (group.parentGroupKey === 'viewItems') {
      _currentGroup = group.key
    }
  })

  //viewItems.sessions.dataConstraints.dataConstraintItems

  const squaresContext = useContext(SquaresContext)
  const { squares_state } = squaresContext ?? {}
  const { keyPath, pageView } = squares_state ?? {}

  // settingsParentContext
  const settingsParentContext = useContext(SettingParentContext)
  const { states } = settingsParentContext ?? {}
  const { eventInfo_state } = states ?? {}
  const { staticViews, appDataDocuments } = eventInfo_state ?? {}

  const { selectedItem, selectedIndex } = {}

  const [dcProps, setDcProps] = useState()
  const [_currentSettingValues, set_currentSettingValues] = useState([])
  const [currentQueryData, setCurrentQueryData] = useState(selectedItem ?? {})

  // setting up the appFormType
  useEffect(() => {
    const _dcProps = {}
    switch (formItemType) {
      case gEnums.formItemTypes.dataConstraintList:
        _dcProps.appFormType = appFormTypes.query
        _dcProps.subKey = 'dataConstraintItems'
        break;
      case gEnums.formItemTypes.dataMatchConstraintList:
        _dcProps.appFormType = appFormTypes.dataQuery
        _dcProps.subKey = 'dataMatchConstraintItems'
        break;
      case gEnums.formItemTypes.appUserDataConstraintList:
        _dcProps.appFormType = appFormTypes.appUserDataQuery
        _dcProps.subKey = 'appUserDataConstraintItems'
        break;
      case gEnums.formItemTypes.pageConstraintList:
        _dcProps.appFormType = appFormTypes.appUserQuery
        _dcProps.subKey = 'pageConstraintItems'
        break;
      case gEnums.formItemTypes.imagePropList:
        _dcProps.appFormType = appFormTypes.imagePropList
        _dcProps.subKey = 'dataPropImages'
        break;
      default:
      // nothing
    }

    setDcProps(_dcProps)

    const _apsView = squares_state?.apsViews?.[pageView]
    const _currentSetting = _.get(_apsView, keyPath, [])
    if (showLogs) {
      console.group('_apsView 2')
      console.log('pageView', pageView, _apsView)
      console.log('keyPath', keyPath)
      console.log('_currentSetting', _currentSetting)
      console.log('appDataDocuments', appDataDocuments)
      console.log('staticViews', staticViews)
      console.groupEnd()
    }
    set_currentSettingValues(_currentSetting)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formItemType]);

  const handleUpdate_queryDataLocal = (d) => {
    // const { dataPropName, queryType, propValue } = d ?? {}

    // console.log('d', d)
    // dataPropName, queryType, propValue, propValues, valueIsString, propStringValue
    // const _d = { ...currentQueryData }
    // if (_d.dataPropName && (_d.dataPropName !== dataPropName)) {
    //   _d.propValue = null
    //   _d.propValues = null
    //   setCurrentQueryData(_d)
    // } else {
    setCurrentQueryData(d)
    // }
  }

  // updates the contraint bacck to the parent
  const handleUpdate_list = () => {
    // const _updateProps = { ...updateProps, subKey: dcProps.subKey }
    // _updateProps.formKey = key_psi
    const { dataPropName, queryType, propValue, propValues, propStringValue, valueIsString } = currentQueryData

    const selectedQueryData = {
      dataPropName,
      queryType,
      propValue,
      propValues,
      propStringValue,
      valueIsString
    }

    if (propValue && dataPropName) {
      const appDd = appDataDocuments?.[dataPropName]
      const appDdi = _.find(appDd, { name: propValue })
      selectedQueryData.propValue = appDdi?._itemKey ? appDdi?._itemKey : propValue
    }

    _.forEach(selectedQueryData, (di, diKey) => {
      if (!selectedQueryData[diKey]) {
        delete selectedQueryData[diKey]
      }
    })

    const _items = [..._currentSettingValues]

    if (selectedIndex || selectedIndex === 0) {
      _items[selectedIndex] = selectedQueryData
    } else {
      _items.push(selectedQueryData)
    }
    console.group('DataConstraintList')
    console.log('constraint items', _items)
    console.groupEnd()
    const _currentPath = currentPath.replace(formItemType, dcProps.subKey)
    const _currentPathFull = currentPathFull.replace(formItemType, dcProps.subKey)
    handle_formUpdate(_items, _currentPath, _currentPathFull, true)
    // formData, updateProps 
    // viewSettings_handlers.handleFormDataChange_settings(_items, _updateProps)
    // swipeToSelected()
  }

  const querySeg = () => {
    switch (formItemType) {
      case gEnums.formItemTypes.dataConstraintList:
      case gEnums.formItemTypes.dataMatchConstraintList:
      case gEnums.formItemTypes.appUserDataConstraintList:
      case gEnums.formItemTypes.pageConstraintList:
        return <Segment basic inverted>{queryLineItem(currentQueryData, staticViews)}</Segment>
      case gEnums.formItemTypes.imagePropList:
        return <Segment basic inverted>{imageLineItem(currentQueryData, staticViews)}</Segment>
      default:
      // nothing
    }
  }

  const queryForm = () => <AppForm
    appFormType={dcProps.appFormType}
    handleSave={handleUpdate_list}
    handleSaveCaption={selectedItem ? 'Update Constraint' : 'Add Constraint'}
    handleUpdateParentData={handleUpdate_queryDataLocal}
    data_parent={currentQueryData}
    _formAttributes={{ inverted: true }}
    _header={querySeg()}
  />

  return dcProps ? queryForm() : <div></div>

}

const dqw = (content, addComma, isArray) => {
  if (addComma) {
    return <div className={(isArray ? 'isa' : null)}>{" '"}{content}{"', "}</div>
  } else {
    return <div className={(isArray ? 'isa' : null)}>{" '"}{content}{"' "}</div>
  }
}

const sqw = (content, addComma) => {
  if (addComma) {
    return <span>{" '"}{content}{"', "}</span>
  } else {
    return <span>{" '"}{content}{"' "}</span>
  }
}

const bw = (content) => {
  return <div>{"["}{content}{"]"}</div>
}

export const queryLineItem = (item, staticViews) => {

  const {
    fromGlobal,
    dataPropName,
    matchingDataPropName,
    queryType,
    propValue,
    propValues,
    valueIsString,
    propStringValue,
  } = item

  const isArray = staticViews && staticViews[dataPropName]

  const nameSpans = () => {
    if (propValues) {
      const v = propValues.map((pv, index) => (sqw(getStaticName(staticViews, dataPropName, pv), index < propValues.length - 1)))
      return bw(v)
    } else if (propValue) {
      return sqw(getStaticName(staticViews, dataPropName, propValue))
    } else if (valueIsString && propStringValue) {
      return sqw(propStringValue)
    } else if (matchingDataPropName) {
      return sqw(matchingDataPropName)
    } else {
      return sqw('value')
    }
  }

  let cn = 'query-line'
  if (fromGlobal) { cn += ' fglb' }

  return <div className={cn}>
    {dqw(dataPropName ? dataPropName : 'dataPropName', true, isArray)}
    {dqw(queryType ? queryType : 'queryType', true)}
    {nameSpans()}
  </div>
}

export const imageLineItem = (item, staticViews) => {

  const { dataPropName, propIconImage, propValue, propValues, valueIsString, propStringValue } = item

  const isArray = staticViews && staticViews[dataPropName]

  const nameSpans = () => {
    if (propValues) {
      const v = propValues.map((pv, index) => (sqw(getStaticName(staticViews, dataPropName, pv), index < propValues.length - 1)))
      return bw(v)
    } else if (propValue) {
      return sqw(getStaticName(staticViews, dataPropName, propValue))
    } else if (valueIsString && propStringValue) {
      return sqw(propStringValue)
    } else {
      return sqw('value')
    }
  }

  return <div className={'query-line'}>
    {dqw(dataPropName ? dataPropName : 'dataPropName', true, isArray)}
    {dqw(propIconImage ? propIconImage : 'propIconImage', true)}
    {nameSpans()}
  </div>
}

export default DataConstraintBuilder